export default {
    namespaced: true,
    state: () => ({
        laborContractActivity: '0'
    }),
    getters: {
        laborContractActivity: state => state.laborContractActivity,
    },
    mutations: {
        setActivity(state, payload = {}) {
            state.laborContractActivity = payload
        },
    },
    actions: {}
}
